'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popoverContextPropType = exports.ConsumesPopoverContext = exports.Provider = exports.Consumer = exports.types = undefined;

var _react = require('react');

var _consumerDecoratorFactory = require('./consumerDecoratorFactory');

var _consumerDecoratorFactory2 = _interopRequireDefault(_consumerDecoratorFactory);

var _Use = require('../tooltip/utils/Use');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = exports.types = {
  use: _react.PropTypes.oneOf(Object.keys(_Use.USE_CLASSES)).isRequired
};

var _createContext = (0, _react.createContext)(),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

exports.Consumer = Consumer;
exports.Provider = Provider;
var ConsumesPopoverContext = exports.ConsumesPopoverContext = (0, _consumerDecoratorFactory2.default)('popover', Consumer);

var popoverContextPropType = exports.popoverContextPropType = _react.PropTypes.shape(types);